import { Button } from 'react-bootstrap';

/**
 * Variantes: 'primary' | 'accent' | 'ghost' | 'danger' | 'dangerSoft'
 * Mapeia para a paleta MowFome.
 */
function AppButton({ variant = 'primary', children, ...props }) {
  const variantMap = {
    primary: 'primary',
    accent: 'warning',
    ghost: 'outline-primary',
    danger: 'danger',
    dangerSoft: 'outline-danger',
  };

  return (
    <Button variant={variantMap[variant] ?? variantMap.primary} {...props}>
      {children}
    </Button>
  );
}

export default AppButton;
